import { Lang } from "@gc/models";

export function detectBrowserLanguage(): Lang {
  // @ts-ignore
  const language = navigator.userLanguage || navigator.language;
  return language.substr(0, 2) === "de" ? "de" : "en";
}
